const baseURL = "/v1/Formacao";

const service = {
  methods: {
    $buscar(params) {
      return this.$api().get(`${baseURL}/FormacaoParaHistorico`, params);
    },
    $visualizar(id) {
      return this.$api().get(`${baseURL}/VisualizarDetalhe/${id}`);
    },
    $visualizarQuestionarioParticipante(params) {
      return this.$api().get(`${baseURL}/VisualizarAvaliacao`, params);
    },
    $enviarRespostasAvaliacao(body, id) {
      return this.$api().put(`${baseURL}/RealizarAvaliacao/${id}`, body);
    },
    $obterAvaliacaoPDF(params) {
      return this.$api().get(`${baseURL}/BaixarAvaliacaoPdf`, this.$getParamsObject(params));
    },
  },
};

export default service;